var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',_vm._b({on:{"click":function($event){$event.stopPropagation();return _vm.$_clickAction($event)}}},'th',_vm.$_attributes,false),[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$_label)}}),_vm._v(" "),_c('i',{class:_vm.iconClass})])}
var staticRenderFns = []

export { render, staticRenderFns }